import get from 'lodash/get';
import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { UserMigrationDetails } from 'all-in-one-shared-api/dist/apis/user/usePatchExistingUser';

import { MemberInformationCard, WeCareFormWrapper } from '../components';

import { ActionType, RegistrationFlowContext } from 'contexts/registration';

import { sessionStorageService, SessionStorageKey } from 'utils/SessionStorageService';
import { osName, osVersion } from 'react-device-detect';

const WeCareLoginView = () => {
  const [keycloakError, setKeycloakError] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  const { dispatch } = useContext(RegistrationFlowContext);

  const loginWithRetry = (loginParams: UserMigrationDetails, maxAttempts: number) =>
    new Promise<void>((resolve, reject) => {
      const keycloakLogin = async (attempt = 1) => {
        try {
          setIsLoading(true);
          await keycloak.login({ ...loginParams, device: osName, deviceVersion: osVersion });
          setKeycloakError(undefined);
          resolve();
        } catch (error: unknown) {
          const errorMessage = error instanceof Error ? error.message : undefined;
          // console.log('loginWithRetry()->error from keycloak.login():', errorMessage);
          setKeycloakError(errorMessage);
          if ((errorMessage && !errorMessage.includes('auth error')) || attempt > maxAttempts) {
            setIsLoading(false);
            reject(error);
          } else {
            setTimeout(() => keycloakLogin(attempt + 1), 500);
          }
        }
      };

      keycloakLogin();
    });

  const login = async (loginParams: UserMigrationDetails) => {
    try {
      await loginWithRetry(loginParams, 2);
      dispatch({ type: ActionType.UpdateFormData, payload: { ...loginParams } });
      sessionStorageService.remove(SessionStorageKey.WecareMobile);
      sessionStorageService.remove(SessionStorageKey.WecareCountryCode);
      navigate('/we-care-login/login-information');
    } catch (error: unknown) {
      setIsLoading(false);
      if (typeof error === 'object' && error !== null) {
        const errorMsg = get(error, 'message');
        setKeycloakError(errorMsg ?? 'Login Error');
      }
    }
  };

  const handleCloseSnackbar = () => {
    setKeycloakError(undefined);
  };

  return (
    <WeCareFormWrapper
      isLoading={isLoading}
      onSubmit={login}
      error={keycloakError}
      handleCloseSnackbar={handleCloseSnackbar}
    >
      <MemberInformationCard />
    </WeCareFormWrapper>
  );
};

export default WeCareLoginView;
